module.exports = __webpack_public_path__ + "static/media/abacus.ea040a5d.svg";